/**
 * @file checklist-data.ts
 * @description checklist 字段的纯数据结构与读写助手（无 React / antd 依赖）。
 *
 * 抽离原因：
 *  1. 让渲染层（ChecklistField / ChecklistRow）与数据语义解耦；
 *  2. 这些 helper 是渲染性能的根基——`writeClause` 只替换被编辑 clause 的对象引用，
 *     其余 clause 引用保持不变，从而让 `React.memo(ChecklistRow)` 对未编辑行 bail-out。
 *     该「引用稳定」不变量极易在后续改动中被破坏，故抽成纯模块并以 node 环境单测锁死
 *     （见 checklist-data.test.ts）。
 */
/**
 * 未填 clause 的兜底值。**必须是模块级常量**：`readClause` 对缺省条目恒返回同一引用，
 * 配合 React.memo 让从未填写的行稳定 bail-out（不可改成每次新建对象）。
 */
export const EMPTY_CLAUSE = { result: null, note: '', attachments: [] };
/**
 * 安全读取一条 clause 的当前值；missing 时回退到 EMPTY_CLAUSE，
 * 避免 controlled / uncontrolled 抖动，并保证缺省行的引用稳定。
 */
export function readClause(value, clauseId) {
    return value[clauseId] ?? EMPTY_CLAUSE;
}
/**
 * 写回单条 clause：只替换该 clauseId 的对象，其余条目保持原引用（memo bail 的关键）。
 * 空值的 clause 仍保留 key 便于后续比对。
 */
export function writeClause(value, clauseId, patch) {
    const current = readClause(value, clauseId);
    return { ...value, [clauseId]: { ...current, ...patch } };
}
//# sourceMappingURL=checklist-data.js.map